import { Injectable, Inject, OnDestroy, Provider } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import {
  Action,
  ActionReducer,
  ActionReducerMap,
  ActionReducerFactory,
  StoreFeature,
} from './models';
import { INITIAL_STATE, INITIAL_REDUCERS, REDUCER_FACTORY } from './tokens';
import { omit, createReducerFactory } from './utils';
import { ActionsSubject } from './actions_subject';
/**
 * @abstract
 */
export abstract class ReducerObservable extends Observable<
  ActionReducer<any, any>
> {}
/**
 * @abstract
 */
export abstract class ReducerManagerDispatcher extends ActionsSubject {}
export const /** @type {?} */ UPDATE = /** @type {?} */(( '@ngrx/store/update-reducers' as '@ngrx/store/update-reducers'));
export class ReducerManager extends BehaviorSubject<ActionReducer<any, any>>
  implements OnDestroy {
/**
 * @param {?} dispatcher
 * @param {?} initialState
 * @param {?} reducers
 * @param {?} reducerFactory
 */
constructor(
private dispatcher: ReducerManagerDispatcher,
private initialState: any,
private reducers: ActionReducerMap<any, any>,
private reducerFactory: ActionReducerFactory<any, any>
  ) {
    super(reducerFactory(reducers, initialState));
  }
/**
 * @param {?} __0
 * @return {?}
 */
addFeature({
    reducers,
    reducerFactory,
    metaReducers,
    initialState,
    key,
  }: StoreFeature<any, any>) {
    const /** @type {?} */ reducer =
      typeof reducers === 'function'
        ? (state = initialState, action: any) => reducers(state, action)
        : createReducerFactory(reducerFactory, metaReducers)(
            reducers,
            initialState
          );

    this.addReducer(key, reducer);
  }
/**
 * @param {?} __0
 * @return {?}
 */
removeFeature({ key }: StoreFeature<any, any>) {
    this.removeReducer(key);
  }
/**
 * @param {?} key
 * @param {?} reducer
 * @return {?}
 */
addReducer(key: string, reducer: ActionReducer<any, any>) {
    this.reducers = { ...this.reducers, [key]: reducer };

    this.updateReducers();
  }
/**
 * @param {?} key
 * @return {?}
 */
removeReducer(key: string) {
    this.reducers = omit(this.reducers, key);

    this.updateReducers();
  }
/**
 * @return {?}
 */
private updateReducers() {
    this.next(this.reducerFactory(this.reducers, this.initialState));
    this.dispatcher.next({ type: UPDATE });
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    this.complete();
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ReducerManagerDispatcher, },
{type: undefined, decorators: [{ type: Inject, args: [INITIAL_STATE, ] }, ]},
{type: undefined, decorators: [{ type: Inject, args: [INITIAL_REDUCERS, ] }, ]},
{type: undefined, decorators: [{ type: Inject, args: [REDUCER_FACTORY, ] }, ]},
];
}

function ReducerManager_tsickle_Closure_declarations() {
/** @type {?} */
ReducerManager.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ReducerManager.ctorParameters;
/** @type {?} */
ReducerManager.prototype.dispatcher;
/** @type {?} */
ReducerManager.prototype.initialState;
/** @type {?} */
ReducerManager.prototype.reducers;
/** @type {?} */
ReducerManager.prototype.reducerFactory;
}


export const /** @type {?} */ REDUCER_MANAGER_PROVIDERS: Provider[] = [
  ReducerManager,
  { provide: ReducerObservable, useExisting: ReducerManager },
  { provide: ReducerManagerDispatcher, useExisting: ActionsSubject },
];

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/store/src/reducer_manager.ts